<label>
  <div
    class="form-field__label form-field__text-label"
    [class.form-field__label--error]="showError"
  >
    {{ field?.label | translateInline }}
  </div>
  <input
    nextDateFormat
    [(ngModel)]="isoDate"
    type="text"
    inputmode="numeric"
    pattern="[0-9]*"
    autocomplete="off"
    class="form-field__input form-field__text-input"
    [class.form-field__input--error]="showError"
    (blur)="_onTouched()"
    [attr.autocomplete]="autocomplete()"
  />

  <div class="form-field__error-message">
    @if (showError && control.errors) {
      <div>
        {{ control.errors | declarativeErrorMessage: field : declaration }}
      </div>
    }
  </div>
</label>
